/* eslint-disable no-unused-vars, indent */
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Button, Table, message, Select } from "antd";
import "./style.scss";
import API from "../../../api";
import urls from "../../../api/urls";
import { capitalize, convertDate, showErrorMessage } from "../../../utils";
import Heading from "../../../components/Heading";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

const {
  GET_EWAY_VALIDITY,
  EXTEND_EWAY_VALIDITY,
  EWAYBILL,
  POST_EWAY_VALIDITY,
} = urls;

const ExtendEWayBill = ({ handleTabChange = () => { } }) => {
  const { Option } = Select;
  const [tableData, setTableData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(0); // backend is 0-based
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [hubDetails, setHubDetails] = useState({});

  useEffect(() => {
    getTableData(0, pageSize);
  }, []);

  let fun = (str) => {
    const date = new Date(str.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
    const formattedDate = `${date.getDate()}/${date.getMonth() + 1
      }/${date.getFullYear()} ${date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    return formattedDate;
  };

  function getModifiedGST(item) {
    const gstNumber = item?.premises?.gst;
    const firstTwoDigits = gstNumber?.substring(0, 2);
    const modifiedDigits = firstTwoDigits?.startsWith("0")
      ? firstTwoDigits?.substring(1)
      : firstTwoDigits;
    return modifiedDigits;
  }

  const columns = [
    {
      title: "AWb No",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text, record) => (
        <span>
          {record?.childAwbNumber == null
            ? record?.awbNumber
            : record?.childAwbNumber}
        </span>
      ),
    },
    {
      title: "Booking Date",
      dataIndex: "bookingStartTime",
      key: "bookingStartTime",
      render: (text) => <span>{text !== null ? fun(text) : null}</span>,
    },

    {
      title: "E-way Number",
      dataIndex: "ewayBillNumber",
      key: "ewayBillNumber",
    },
    {
      title: "E-way Date Time",
      dataIndex: "ewayBillCreateDate",
      key: "ewayBillCreateDate",
      render: (text) => <span>{text !== null ? fun(text) : null}</span>,
    },
    {
      title: "Status",
      dataIndex: "bookingStatus",
      key: "bookingStatus",
      sorter: (a, b) => a.bookingStatus.localeCompare(b.bookingStatus),

      render: (text) => (
        <div
          style={{
            padding: "6px 2px",

            background: "#52C150",
            borderRadius: "3px",
            color: "#FFF",
          }}
          className="center fw-500"
        >
          {text}
        </div>
      ),
    },

    {
      title: "Valid Upto",
      dataIndex: "expiryDate",
      key: "expiryDate",
      render: (text) => <span>{text !== null ? fun(text) : null}</span>,
    },
    {
      title: "Action",
      // dataIndex: "expiryDate",
      // key: "expiryDate",
      render: (text, record) => {
        return (
          <div>
            <Button
              className=""
              // disabled={_data?.ewayUpdated}
              style={{
                borderRadius: "5px",
                color: "#2E77D0",
                background: "white",
              }}
              onClick={() => extendEway([record])}
            >
              {/* <img src={whiteUpdateIcon} /> */}
              <span className="ml-1 fw-500">E-WAY BILL UPDATED</span>
            </Button>
          </div>
        );
      },
    },
  ];

  const getTableData = async (
    nextPageNo = pageNo,
    nextPageSize = pageSize,
    nextSearchText = searchText
  ) => {
    setLoading(true);
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    let date = year + "-" + month + "-" + day;
    let params = {
      fromDate: date,
      pageNo: nextPageNo,
      pageSize: nextPageSize,
    };
    if (nextSearchText && String(nextSearchText).trim()) {
      // Backend supports search query param
      params.search = String(nextSearchText).trim();
    }
    let response = await API.Api(GET_EWAY_VALIDITY).getwithParams(params);
    if (response.status) {
      setLoading(false);
      setTableData(response.response.data?.shipments || []);
      setHubDetails(response.response.data || {});
      setPageNo(response.response.data?.pageNo ?? nextPageNo);
      setPageSize(response.response.data?.pageSize ?? nextPageSize);
      setTotalCount(response.response.data?.totalCount ?? 0);
    } else {
      setLoading(false);
    }
  };

  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "/" + mm + "/" + yyyy;

  const extendEway = async (records) => {
    if (!records?.length) return;
    setLoading(true);

    const temp = records.map((record) => ({
      ewbNo: record.ewayBillNumber,
      transDocDate: formattedToday,
      addressLine1: hubDetails?.hubName,
      addressLine2: hubDetails?.hubCity,
      addressLine3: hubDetails?.hubState,
      transDocNo: record.awbNumber,
    }));

    let response = await API.Api(POST_EWAY_VALIDITY).patchIdHeader(temp);

    setLoading(false);

    const payload = response?.response?.data;
    const results = Array.isArray(payload) ? payload : payload ? [payload] : [];

    if (!results.length) {
      showErrorMessage("Failed to Update E-way bill");
      return;
    }

    // Backend: status "1" => success, status "0" => failure (show message in `data`)
    const failures = results.filter((r) => String(r?.status) === "0");
    const successes = results.filter((r) => String(r?.status) === "1");

    if (results.length === 1) {
      const r = results[0];
      const msg = r?.data || (String(r?.status) === "1" ? "E-way bill extended successfully" : "Failed to Update E-way bill");
      if (String(r?.status) === "1") message.success(msg);
      else message.error(msg);
    } else {
      if (successes.length) message.success(`E-way bill extended for ${successes.length} shipment(s)`);
      if (failures.length) message.error(failures[0]?.data || `Failed for ${failures.length} shipment(s)`);
    }

    setSelectedRowKeys([]);
    setSelectedRows([]);
    getTableData(pageNo, pageSize);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };

  const hasSelected = selectedRowKeys.length > 0;

  return (
    // <Spin spinning={loading}>
    <div className="m-2">
      <Heading title={"Extend E-way Validity"} />
      <div className="virtual-area-container p-2">
        <div className="extend-eway-toolbar">
          <div className="extend-eway-toolbar__left">
            <div className="extend-eway-toolbar__label">Search</div>
            <Input.Search
              allowClear
              className="extend-eway-toolbar__search"
              placeholder="AWB / E-way bill no."
              value={searchText}
              onChange={(e) => {
                const next = e.target.value;
                setSearchText(next);
                getTableData(0, pageSize, next);
              }}
              onSearch={(value) => {
                setSearchText(value);
                getTableData(0, pageSize, value);
              }}
            />
          </div>
        </div>
        <Row justify="end" className="mt-1">
          <Col>
            <Button
              className="save-btn mb-1"
              disabled={!hasSelected}
              onClick={() => extendEway(selectedRows)}
            >
              EXTEND EWAY VALIDITY ({selectedRowKeys.length})
            </Button>
          </Col>
        </Row>
        <Table
          className="table-head-sticky"
          columns={columns}
          dataSource={tableData}
          pagination={{
            current: pageNo + 1, // antd is 1-based
            pageSize,
            total: totalCount,
            showSizeChanger: true,
            onChange: (page, size) => {
              const nextPageNo = Math.max(0, (page || 1) - 1);
              const nextPageSize = size || pageSize;
              getTableData(nextPageNo, nextPageSize, searchText);
            },
          }}
          rowKey={(record) => record?.awbNumber || record?.ewayBillNumber}
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          rowSelection={{ ...rowSelection }}
        />
      </div>
    </div>
    // </Spin>
  );
};
export default ExtendEWayBill;
